import React from 'react';
import { motion } from 'framer-motion';
import useStore from '@store';
import { Lock, Edit3 } from 'lucide-react';

export default function Header() {
  const {
    listId,
    tier,           // Add this
    isProtected,
    isOwner,
    hasPassword,    // Add this
    openLockDialog,
    openPasswordDialog,
    openPasswordSetDialog,  // Add this
    openShareDialog,
  } = useStore();
  
  const handleShare = () => {
    console.log('handleShare called, showShareDialog state:', useStore.getState().showShareDialog);
    
    if (navigator.share && /mobile/i.test(navigator.userAgent)) {
      navigator.share({
        title: 'LetsNote',
        text: 'Check out this list',
        url: window.location.href,
      }).catch(() => {
        console.log('Native share failed, opening dialog');
        openShareDialog();
      });
    } else {
      console.log('Opening share dialog');
      openShareDialog();
    }
  };
  
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      style={{
        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: 'white',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50
      }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Edit3 size={16} color="white" />
        </div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          margin: 0
        }}>
          LetsNote
        </h1>
      </div>
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        {/* For free users - show Keep Forever button */}
        {tier === 'free' && listId && (
          <button
            onClick={openLockDialog}
            style={{
              background: '#10b981',
              border: 'none',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '8px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            title="Keep this list forever"
          >
            Keep Forever
          </button>
        )}
        
        {/* For paid users without password - show Lock button */}
        {tier === 'paid' && !hasPassword && (
          <button
            onClick={openPasswordSetDialog}
            style={{
              background: 'rgba(255, 255, 255, 0.15)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              padding: '8px 12px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            title="Add password protection"
          >
            <Lock size={16} />
          </button>
        )}
        
        {/* For non-owners of password-protected lists */}
        {hasPassword && !isOwner && (
          <button
            onClick={openPasswordDialog}
            style={{
              background: 'rgba(255, 255, 255, 0.15)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              padding: '8px 12px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            title="Enter password to edit"
          >
            <Lock size={16} />
          </button>
        )}
        
        {listId && (
          <button
            onClick={() => {
              console.log('Share button clicked');
              handleShare();
            }}
            style={{
              background: '#1e40af',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '8px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
          >
            Share
          </button>
        )}
      </div>
    </motion.header>
  );
}